/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:30
 * @LastEditors: yy
 * @LastEditTime: 2019-08-26 13:28:46
 */


import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './BrandSelect.css';
import BrandComPic from './brandComPic.jpg'
import cx from 'classnames'


import ImgIcon from '../Imgicon'

class BrandSelect extends React.Component {
  constructor(props){
    super(props)
    this.state={
       seaCompleteItem:props.autoComplete||[],
       isFixed:false,
       listIndex: 0,
      //  seaCompleteItem:[],
       selectIndex: 0,
       showCom:false
    }
    this.mouseLeaveCon=true
    
   this.mouseSlect=this.mouseSlect.bind(this)
   this.mouseLeave=this.mouseLeave.bind(this)
   this.mouseEnter=this.mouseEnter.bind(this)
   this.isFocusFalse=this.isFocusFalse.bind(this)
   this.keyDown=this.keyDown.bind(this)
   this.doBrandBattle=this.doBrandBattle.bind(this)
   this.handleClick=this.handleClick.bind(this)
 }


 

 doBrandBattle=()=>{
   console.log(this.state.value,'进行品牌对比')
 }

 mouseEnter=()=>{
   // console.log('进入')
   
  //  this.setState({mouseLeave:false})
  this.mouseLeaveCon=true
 }
 mouseLeave=()=>{
   // console.log('likai')
  //  this.setState({mouseLeave:true})
   this.mouseLeaveCon=false
 }

 mouseSlect=(index)=>{
   this.setState({selectIndex:index})
 }


 
 isFocusFalse=()=> {
   // console.log('失去焦点')
   if(!this.mouseLeaveCon){
     this.setState({
       showCom:false
     })
   }
 
 }
//  componentWillReceiveProps = (nextProps) => {
//    if(nextProps.items!=this.props.items){
//     console.log('1111111111111111111----------------cwrp')
//     console.log(nextProps.items,this.props.items)
//    const {items,autoComplete}=nextProps
//    let seaCompleteItem=autoComplete
 
//    let [brandID,comID]=[[],[]]
 
//    for( var key of items){
//      brandID.push(key.id)
//    }
//    let aa=[]
   
 
//    seaCompleteItem.forEach((value,key)=>{
//     //  console.log(value,key)
//      brandID.indexOf(value.id)>-1?seaCompleteItem.splice(key,1):seaCompleteItem
//    })
 
//   //  console.log(autoComplete,seaCompleteItem)
//     this.setState({seaCompleteItem})
//    }
//  }
componentWillReceiveProps(nextProps) {
  if(nextProps.autoComplete!=this.props.autoComplete){


    this.setState({seaCompleteItem:nextProps.autoComplete})
  }else if(nextProps.items!=this.props.items){

    const {items,autoComplete}=nextProps
    const {seaCompleteItem}=this.state
 
    let [brandID,comList]=[[],[]]
  
    for( var key of items){
      brandID.push(key.id)
    }
  
  
    autoComplete&&autoComplete.filter((i,index)=>{
      
       brandID.indexOf(i.id)<0?comList.push(i):null 

    })
    
  
    this.setState({seaCompleteItem:comList})
  }
}
 

 keyDown=(e)=> {
   
       const { selectIndex, seaCompleteItem, value, } = this.state
       const num =  seaCompleteItem.length-1

       // console.log(value,num,selectIndex,'aaaaaaaaaaaaaaaaaaaaaaaa',e.key,selectIndex<0)
      if(e.key=='ArrowUp'&&seaCompleteItem.length!=0){


           let cc=selectIndex<1?num:selectIndex-1
           this.setState({selectIndex:cc})
      }else if(e.key=='ArrowDown'&&seaCompleteItem.length!=0){

           // this.setState({selectIndex:selectIndex+1,value:items[num]['name']})
           let cc=selectIndex<1?selectIndex+1:selectIndex+1
           this.setState({selectIndex:cc})
     }else if(e.key=='Backspace'&&value.length==1){
         this.setState({seaCompleteItem:[]})

     }
         
   
 }
 

 handleSubmit(e){
   const{seaCompleteItem,selectIndex,value}=this.state
   const {items,battle}=this.props
   // console.log(seaCompleteItem,selectIndex)
   e.preventDefault()
 }



 handleClick=(name)=>{
 
  this.setState({value:'',showCom:false})
  
  this.mouseLeaveCon=false
  this.props.doBattle(name)


 }


 render() {

   const {seaCompleteItem,selectIndex,value,showCom}=this.state
   const {items,battle,autoComplete}=this.props

 
   return(
     <div className={s.root}>
       
       <div className={s.cardInput}>
             
             {/* <select>
               {autoComplete.map((i,index)=>
                  <option key={index}>{i}</option>
               )}
             </select> */}
             <div className={s.posi}>

              <input className={s.addContrast} 
                   onClick={()=>this.setState({showCom:true})}
                   onBlur={this.isFocusFalse}
                   value={value}
                   placeholder='选择同行业品牌'
              />
              <i className={s.seaIcon} onClick={()=>{
                  
                }}><img src={BrandComPic} /></i>
                
              {autoComplete&&autoComplete.length>0&&showCom&&
                <div className={s.scrollList}>
                  <ul className={ s.seaItems} 
                      onMouseLeave={this.mouseLeave}
                      onMouseEnter={this.mouseEnter}
                  >
                  {/* style={{left:`${items.length==1?'297px':'597px'}`}} */}
                  {/* {filtersBrand()} */}
                  
                    {seaCompleteItem
                      .map((item, index) => (
                        <li key={index} className={selectIndex == index ? cx(s.seaItem, s.seaAc) : s.seaItem}
                            onMouseEnter={()=>this.mouseSlect(index)}
                            onClick={()=>this.handleClick(item.name)}
                        >
                          {/* <i><img src={`/digitalAssets/resources/img/LOGO/${item.id}.png`} /></i> */}
                          <ImgIcon id={item.id}/>
                          {item.name}
                        </li>

                      ))}
                      
                  </ul>
                </div>
                  
              }
              </div>
             
             
           </div>
       
      </div>
    )


   
  }
}

export default withStyles(s)(BrandSelect);



// WEBPACK FOOTER //
// src/components/BrandSelect/BrandSelect.js